import React, { Component } from 'react';
import * as customers from 'customers/actions/customers';
import { connect } from 'react-redux';
import { DetailContainer } from 'customers/DetailContainer';
import Loading from 'apa/components/Loading';
import autobind from 'autobind-decorator';

@connect(
    state => {
        return {
            customers: state.customers,
            auth: state.apa
        }
    },
    dispatch => {
        return {
            fetchCustomer: (customer_id, callback) => {
                dispatch(customers.fetchCustomer(customer_id, callback))
            }
        }
    }
)
export default class EmployeeList extends Component {


    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            customer: null,
            newEmployee: {
                count: '',
                date: '',
            },
            newEmployeeHours: {
                hours: '',
                created: ''
            },
            employeeList: [],
            hourList: []
        };
    }

    @autobind
    getCustomer() {
        const id = this.props.match.params.id;
        this.props.fetchCustomer(id,
            customer => this.setState({
                isLoading: false,
                customer: customer,
                newEmployee: {
                    ...this.state.newEmployee,
                    customer: customer.id
                },
                newEmployeeHours: {
                    ...this.state.newEmployeeHours,
                    customer: customer.id
                },
                employeeList: customer.employees,
                hourList: customer.hours
            }
            )
        );
    }

    componentDidMount() {
        this.getCustomer()
    }

    @autobind
    addNewParameter(event) {
        event.preventDefault()
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        const body = JSON.stringify(
            this.state.newEmployee
        )
        fetch(
            '/api/employees/',
            { headers, method: 'POST', body}
        ).then(
            res => res.json()
        ).then(
            parameter => this.setState({
                employeeList: [parameter, ...this.state.employeeList]
            })
        )   
    }
    @autobind
    addNewHour(event) {
        event.preventDefault()
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        const body = JSON.stringify(
            this.state.newEmployeeHours
        )
        fetch(
            '/api/employees_hours/',
            { headers, method: 'POST', body}
        ).then(
            res => res.json()
        ).then(
            parameter => this.setState({
                hourList: [parameter, ...this.state.hourList]
            })
        )   
    }

    @autobind
    changeNewParameterInput(event) {
        const {name, value} = event.target;
        this.setState({
            newEmployee: {
                ...this.state.newEmployee,
                [name]: value
            }
        })
    }

    @autobind
    changenewEmployeeHoursInput(event) {
        const {name, value} = event.target;
        this.setState({
            newEmployeeHours: {
                ...this.state.newEmployeeHours,
                [name]: value
            }
        })
    }

    @autobind
    deleteParameter(event, parameter) {
        event.preventDefault()
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        fetch(
            `/api/employees/${parameter.id}/`,
            { headers, method: 'DELETE'}
        ).then(
            () => this.setState({
                employeeList: this.state.employeeList.filter(o => parameter.id !== o.id)
            })
        )   
    }

    @autobind
    deleteHour(event, parameter) {
        event.preventDefault()
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        fetch(
            `/api/employees_hours/${parameter.id}/`,
            { headers, method: 'DELETE'}
        ).then(
            () => this.setState({
                hourList: this.state.hourList.filter(o => parameter.id !== o.id)
            })
        )   
    }


    render() {
        if (this.state.isLoading)
            return <Loading />;
        const id = this.props.match.params.id;
        const customer = this.state.customer;
        const employeeList = this.state.employeeList
        const hourList = this.state.hourList
        return (
            <DetailContainer id={id}>
                <h1>{customer.name}</h1>
                <form className="form-inline" onSubmit={this.addNewParameter}>
                    <input required className="form-control" type="number" placeholder="Mitarbeiteranzahl" name="count" min="0" step="1" value={this.state.newEmployee.count} onChange={this.changeNewParameterInput}/>
                    <input required className="form-control" type="date" placeholder="Datum" name="date" value={this.state.newEmployee.date} onChange={this.changeNewParameterInput} />
                    <button type="submit" className="btn btn-primary">Hinzufügen</button>
                </form>
                <br/>
                {
                    employeeList.map(
                        parameter => <p key={`parameter_${parameter.id}`}>Mitarbeiteranzahl: {parameter.count} Datum: {parameter.date} <a href="#" onClick={e=>this.deleteParameter(e, parameter)}>Löschen</a></p>
                    )
                }
                <form className="form-inline" onSubmit={this.addNewHour}>
                    <input required className="form-control" type="number" placeholder="Mitarbeiterstunden" name="hours" min="0" step="0.1" value={this.state.newEmployeeHours.count} onChange={this.changenewEmployeeHoursInput}/>
                    <input required className="form-control" type="date" placeholder="Datum" name="created" value={this.state.newEmployeeHours.date} onChange={this.changenewEmployeeHoursInput} />
                    <button type="submit" className="btn btn-primary">Hinzufügen</button>
                </form>
                <br/>
                {
                    hourList.map(
                        parameter => <p key={`parameter_${parameter.id}`}>Mitarbeiterstunden: {parameter.hours} Datum: {parameter.created} <a href="#" onClick={e=>this.deleteHour(e, parameter)}>Löschen</a></p>
                    )
                }
            </DetailContainer>
        )
    }
}

